import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

interface OriginalGameCardSkeletonProps {
	className?: string
}

export function OriginalGameCardSkeleton({ className }: OriginalGameCardSkeletonProps) {
	return <Skeleton className={cn('h-[200px] w-[150px] shrink-0 rounded-2xl', className)} />
}
